import { render, staticRenderFns } from "./Cfooter.vue?vue&type=template&id=575861a6&"
import script from "./Cfooter.vue?vue&type=script&lang=js&"
export * from "./Cfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports